export default {
      id: "Icon--triangleRight-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--triangleRight",
      toString: function () {
        return this.url;
      }
    }